import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import AnimatedLoader from "@hl/base-components/lib/AnimatedLoader";
import { UserPlus01 } from "@hl/base-components/lib/assets/icons/HDS";
import { Button, Center, ScrollArea, Stack, Text } from "@mantine/core";
import { useAuth } from "../../../auth";
import { useWatchlistAndFollowContext } from "../../WatchlistAndFollowContext";
import { useGetFollowersQuery } from "../follow.graphql.generated";
import { FollowerTile } from "./FollowerTile";
export const FollowersTab = (props) => {
    var _a, _b, _c;
    const auth = useAuth();
    const { walletAddress, limit = 50 } = props;
    const { isFollowing, follow } = useWatchlistAndFollowContext();
    const { data, loading, error, fetchMore, refetch } = useGetFollowersQuery({
        ...props,
        variables: {
            input: {
                walletAddress: walletAddress,
                limit: 50,
                cursor: null,
            },
        },
        fetchPolicy: "cache-and-network",
    });
    const followers = (_a = data === null || data === void 0 ? void 0 : data.getFollowers) === null || _a === void 0 ? void 0 : _a.edges;
    const endCursor = (_c = (_b = data === null || data === void 0 ? void 0 : data.getFollowers) === null || _b === void 0 ? void 0 : _b.pageInfo) === null || _c === void 0 ? void 0 : _c.endCursor;
    const hasMore = endCursor != null;
    const isMine = walletAddress === auth.walletAddress;
    const handleLoadMore = () => {
        fetchMore({
            variables: {
                input: {
                    walletAddress: walletAddress,
                    cursor: endCursor,
                    limit,
                },
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                var _a, _b, _c, _d;
                const dedup = new Set();
                fetchMoreResult.getFollowers.edges = [
                    ...((_b = (_a = previousResult === null || previousResult === void 0 ? void 0 : previousResult.getFollowers) === null || _a === void 0 ? void 0 : _a.edges) !== null && _b !== void 0 ? _b : []),
                    ...((_d = (_c = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.getFollowers) === null || _c === void 0 ? void 0 : _c.edges) !== null && _d !== void 0 ? _d : []),
                ].filter((item) => {
                    if (dedup.has(item.walletAddress)) {
                        return false;
                    }
                    dedup.add(item.walletAddress);
                    return true;
                });
                return fetchMoreResult;
            },
        });
    };
    if (followers == null && loading) {
        return (_jsx(Center, { mih: 400, mah: 400, children: _jsx(Stack, { align: "center", spacing: 0, children: _jsx(AnimatedLoader, { size: 72 }) }) }));
    }
    if (followers == null || error != null) {
        return (_jsx(Center, { mih: 400, mah: 400, children: _jsx(Text, { c: "tertiaryText", children: "Something went wrong" }) }));
    }
    if (followers.length === 0) {
        return (_jsx(Center, { mih: 400, mah: 400, children: _jsxs(Stack, { children: [_jsx(Text, { c: "tertiaryText", children: "No followers so far" }), !isMine && (_jsx(Button, { color: "primaryButton", leftIcon: _jsx(UserPlus01, {}), onClick: async () => {
                            await follow(walletAddress, true);
                            refetch();
                        }, children: "Be the first!" }))] }) }));
    }
    return (_jsx(ScrollArea, { h: 400, mt: 16, offsetScrollbars: true, type: "auto", children: _jsxs(Stack, { spacing: 0, align: "start", children: [[...followers].map((follower) => {
                    var _a;
                    const publicAccountSettings = follower.publicAccountSettings;
                    const avatar = publicAccountSettings === null || publicAccountSettings === void 0 ? void 0 : publicAccountSettings.displayAvatar;
                    const displayName = (_a = publicAccountSettings === null || publicAccountSettings === void 0 ? void 0 : publicAccountSettings.displayName) !== null && _a !== void 0 ? _a : publicAccountSettings === null || publicAccountSettings === void 0 ? void 0 : publicAccountSettings.wallet.ensName;
                    const verified = !!(publicAccountSettings === null || publicAccountSettings === void 0 ? void 0 : publicAccountSettings.verified);
                    const following = isFollowing(follower.walletAddress);
                    return (_jsx(FollowerTile, { walletAddress: follower.walletAddress, displayName: displayName, avatarUrl: avatar, isFollowing: following, verified: verified, onFollowClick: () => {
                            follow(follower.walletAddress, !following);
                        } }, follower.walletAddress));
                }), hasMore && (_jsx(Center, { w: "100%", mt: 16, children: _jsx(Button, { color: "secondaryButton", onClick: handleLoadMore, children: "Load more" }) }))] }) }));
};
